/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Financial data of a legal entity for its last declared fiscal year
 * @export
 * @interface LegalEntityFinancialsDto
 */
export interface LegalEntityFinancialsDto {
    /**
     * Revenue of the fiscal year, in euros
     * @type {number}
     * @memberof LegalEntityFinancialsDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof LegalEntityFinancialsDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof LegalEntityFinancialsDto
     */
    fiscalYearEnd: string;
}

/**
 * Check if a given object implements the LegalEntityFinancialsDto interface.
 */
export function instanceOfLegalEntityFinancialsDto(value: object): value is LegalEntityFinancialsDto {
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function LegalEntityFinancialsDtoFromJSON(json: any): LegalEntityFinancialsDto {
    return LegalEntityFinancialsDtoFromJSONTyped(json, false);
}

export function LegalEntityFinancialsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityFinancialsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
    };
}

export function LegalEntityFinancialsDtoToJSON(json: any): LegalEntityFinancialsDto {
    return LegalEntityFinancialsDtoToJSONTyped(json, false);
}

export function LegalEntityFinancialsDtoToJSONTyped(value?: LegalEntityFinancialsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
    };
}

